export default class AtividadeCliente {

  constructor(
    IdEmpresa = 1,
    IdAtividade = null,
    IdCliente = null,
    Fantasia = ''
  ) {

    this.IdEmpresa = IdEmpresa;
    this.IdAtividade = IdAtividade;
    this.IdCliente = IdCliente;
    this.Fantasia = Fantasia;
  }

}